import React, {Component} from 'react';
import {connect} from 'react-redux';
import { Layout, Spin, Button, Icon, Table, Modal } from 'antd';

// Actions
import {
  fetchAllSwitches,
  onDeleteSwitch,
  onSwitchList,
  onSwitchListIsLoading,
  onUndeleteSwitch,
  fetchSwitchConnectionStatus
} from '../../../data/switch/actions';

// Other
import {strings} from '../../../localization';

// Selectors
import {
  getSwitchList,
  getSwitchListIsLoading,
} from '../../../data/switch/selectors';
import { CLOUD_PLANS } from '../../../constants';
import { getValidCloudPlan } from '../../../data/meters/selectors';
import { getDeviceList } from '../../../data/devices/selectors';
import { fetchAllDevices } from '../../../data/devices/actions';
import AddOrEditSwitchModal from './AddOrEditSwitchModal';
import { getAddOrEditSwitchModalIsShown } from '../../../data/homes/selectors';
import { onAddOrEditSwitchModalIsShown } from '../../../data/homes/actions';
import Text from 'antd/es/typography/Text';

const ButtonGroup = Button.Group;

const AddSwitchButton = ({ onClick }) => (
    <Button
        key="add-detail-switch"
        size="default"
        type="primary"
        onClick={onClick}
        style={{margin: 8 }}
    >
      <Icon type="plus" />
      {strings.homes.addSwitch}
    </Button>
);

// eslint-disable-next-line react/no-multi-comp
class SwitchListScreen extends Component {

  state = {
    recordToEdit: undefined,
    recordToDelete: null,
    deleteModalShown: false,
    loadSwitchStatusTimer: undefined,
    switchConnectionStatus: undefined
  };

  componentWillMount() {
    this.loadSwitchStatus(false);
  }

  componentDidUpdate(prevProps) {
    const { meterId, fetchAllSwitches, fetchAllDevices } = this.props;

    if (meterId !== undefined && meterId !== prevProps.meterId) {
      fetchAllSwitches(meterId);
      fetchAllDevices(meterId, true);
      this.loadSwitchStatus(true);
    }
  }

  componentWillUnmount() {
    const { loadSwitchStatusTimer } = this.state;

    clearTimeout(loadSwitchStatusTimer);
  }

  getDeviceObjById = (id) => {
    const {deviceList} = this.props;
    if (id === null || !deviceList) {
      return null;
    }
    const dev = deviceList.filter((item) => item.device === id);
    return dev.length > 0 ? dev[0] : null;
  };

  getDeviceById = (id) => {
    const {deviceList} = this.props;
    if (id === null || !deviceList) {
      return '-';
    }
    const dev = deviceList.filter((item) => item.device === id);
    return dev.length > 0 ? dev[0].name : '-';
  };

  toggleAddOrEditSwitchModal = (isShown, record) => () => {
    const { meterId, fetchAllDevices } = this.props;
    fetchAllDevices(meterId, true);

    if (record && isShown) {
      this.setState({ recordToEdit: record });
    } else if (!isShown) {
      this.setState({ recordToEdit: undefined });
    }

    const { onAddOrEditSwitchModalIsShown } = this.props;
    onAddOrEditSwitchModalIsShown(isShown);
  };

  onAfterAddOrEditSwitchSubmit = () => {
    this.setState({ recordToEdit: undefined });

    const { onAddOrEditSwitchModalIsShown } = this.props;
    onAddOrEditSwitchModalIsShown(false);
  }

  getAvailableSwitchCount = () => {
    const {cloudPlan} = this.props;
    switch (cloudPlan) {
      case 'S':
        return CLOUD_PLANS.STANDARD.LIMITATIONS.SWITCH_COUNT;
      case 'P':
        return CLOUD_PLANS.PREMIUM.LIMITATIONS.SWITCH_COUNT;
      default:
        break;
    }
    return CLOUD_PLANS.BASIC.LIMITATIONS.SWITCH_COUNT;
  };

  isNewSwitchInstallationAllowed = () => {
    const availableSwitchCount = this.getAvailableSwitchCount();
    // Premium:
    if (availableSwitchCount < 0) {
      return true;
    }
    const {switches} = this.props;
    return switches && switches.length < availableSwitchCount;
  };

  combineSwitchAndRelay = (switc, relay) => {
    const flat = {
      switchObj: switc,
      deleted: switc.deleted,
      brand: switc.brand,
      switchType: switc.switchType,
      ip: switc.ip,

      relayObj: relay,
      relayType: relay.relayType,
      device: relay.device,
      priority: relay.priority,
      phase: relay.phase,
      mode: relay.mode,
      readyAt: relay.readyAt,
      switchOffFrom: relay.switchOffFrom,
      switchOffTo: relay.switchOffTo,

      deviceName: this.getDeviceById(relay.device)
    };
    return flat;
  }

  splittSwitchAndRelay = (values, flat) => {
    if (! flat)
      flat = {};
    if (! flat.switchObj)
      flat.switchObj = {};
    flat.switchObj.brand = values.brand;
    flat.switchObj.switchType = values.switchType;
    flat.switchObj.ip = values.ip;
    if (! flat.relayObj) {
      flat.relayObj = {};
      if (! flat.switchObj.relays)
        flat.switchObj.relays = [];
      if (! flat.switchObj.relays[0])
        flat.switchObj.relays[0] = flat.relayObj;
    }
    flat.relayObj.relayType = values.relayType;
    flat.relayObj.device = values.device;
    flat.relayObj.priority = values.priority;
    flat.relayObj.phase = values.phase;
    flat.relayObj.mode = values.mode;
    flat.relayObj.readyAt = values.readyAt;
    flat.relayObj.switchOffFrom = values.switchOffFrom;
    flat.relayObj.switchOffTo = values.switchOffTo;
    flat.relayObj.selector = values.selector;

    flat.relayObj.modbusStateDataType = values.modbusStateDataType;
    flat.relayObj.modbusStateFactor = values.modbusStateFactor;
    flat.relayObj.modbusStateFunctionCode = values.modbusStateFunctionCode;
    flat.relayObj.modbusStateMaxValue = values.modbusStateMaxValue;
    flat.relayObj.modbusStateMinValue = values.modbusStateMinValue;
    flat.relayObj.modbusStateRegisterQuantity = values.modbusStateRegisterQuantity;
    flat.relayObj.modbusStateRegisterStartAddress = values.modbusStateRegisterStartAddress;
    flat.relayObj.modbusTempDataType = values.modbusTempDataType;
    flat.relayObj.modbusTempFactor = values.modbusTempFactor;
    flat.relayObj.modbusTempFunctionCode = values.modbusTempFunctionCode;
    flat.relayObj.modbusTempRegisterQuantity = values.modbusTempRegisterQuantity;
    flat.relayObj.modbusTempRegisterStartAddress = values.modbusTempRegisterStartAddress;
    flat.relayObj.modbusWattDataType = values.modbusWattDataType;
    flat.relayObj.modbusWattFactor = values.modbusWattFactor;
    flat.relayObj.modbusWattFunctionCode = values.modbusWattFunctionCode;
    flat.relayObj.modbusWattRegisterQuantity = values.modbusWattRegisterQuantity;
    flat.relayObj.modbusWattRegisterStartAddress = values.modbusWattRegisterStartAddress;

    return flat.switchObj;
  }

  flatSwitchList = (switches) => {
    const result = [];
    // eslint-disable-next-line guard-for-in
    for (let sw=0; sw < switches.length; sw += 1) {
      // eslint-disable-next-line guard-for-in
      if (switches[sw].relays.length === 0) {
        result.push(switches[sw]);
      } else {
        for (let rel=0; rel < switches[sw].relays.length; rel += 1) {
          const flat = this.combineSwitchAndRelay(switches[sw], switches[sw].relays[rel]);
          result.push(flat);
        }
      }
    }
    return result;
  }

  isAllowedToEdit = () => {
    const { isAdmin, isOwnerOfHouse, isInstaller } = this.props;
    return isAdmin || isOwnerOfHouse || isInstaller;
  };

  onDeleteModalShownToggle = (isShown, switchRecord) => () => {
    if (switchRecord) {
      this.setState({
        recordToDelete: switchRecord
      });
    }
    this.setState({ deleteModalShown: isShown });
  };

  onDeleteModalStateReset = () => {
    this.setState(() => ({
      deleteModalShown: false,
      deleteModalIsLoading: false,
      recordToDelete: null
    }));
  };

  deleteSwitch = () => {
    this.setState({ deleteModalIsLoading: true });

    const { recordToDelete } = this.state;
    const { onDeleteSwitch, onUndeleteSwitch, meterId, fetchAllSwitches } = this.props;
    if (recordToDelete.deleted) {
      onUndeleteSwitch(recordToDelete.switchObj.switch).then(() => {
        this.onDeleteModalStateReset();
        fetchAllSwitches(meterId);
      });
    } else {
      onDeleteSwitch(recordToDelete.switchObj.switch).then(() => {
        this.onDeleteModalStateReset();
        fetchAllSwitches(meterId);
      }).catch(err => {
        this.onDeleteModalStateReset();
        throw err;
      });
    }
  };

  loadSwitchStatus = (manuallyTriggered) => {
    // We use pageIsMounted here even though we could control it with meterId
    // Because we don't want to couple callbacks and meterId
    const { meterId, pageIsMounted, timePeriod } = this.props;
    if (meterId !== undefined) {
      fetchSwitchConnectionStatus(meterId, this.storeSwitchStatus(manuallyTriggered));
    } else if (!manuallyTriggered && pageIsMounted){
        const timer = setTimeout(this.loadSwitchStatus, timePeriod);
        this.setState(() => ({ loadSwitchStatusTimer: timer }));
    }
  }

  storeSwitchStatus = (manuallyTriggered) => {
    const { pageIsMounted, timePeriod } = this.props;
    if (!manuallyTriggered && pageIsMounted) {
      return (status) => {
        const timer = setTimeout(this.loadSwitchStatus, timePeriod);
        this.setState(() => ({ loadSwitchStatusTimer: timer }));
        if (status) {
          this.setState(() => ({ switchConnectionStatus: status }));
        }
      }
    }
    return (status) => {
      if (status) {
        this.setState(() => ({ switchConnectionStatus: status }));
      }
    };
  }

  getStatusColor = (_switch) => {
    const { switchConnectionStatus } = this.state;

    const greenColor = '#1DA57A';
    const redColor = '#FF4D4F';
    const yellowColor = '#FFE607';

    if (switchConnectionStatus !== undefined && _switch.switchObj !== undefined){

        const status = switchConnectionStatus.find(switchStatus => switchStatus.meterId === _switch.switchObj.id);

        if (status !== undefined){
            switch(status.status){
                case 'GREEN':
                    return greenColor;
                case 'YELLOW':
                    return yellowColor;
                default:
                    return redColor;
            }
        }

        return redColor;
    }

    return redColor;
  }

  render() {
    const {isLoading, switches, addOrEditSwitchModalIsShown, meterId, params, deviceList } = this.props;
    const {recordToEdit, recordToDelete, deleteModalShown, deleteModalIsLoading, switchConnectionStatus} = this.state;
    const msgs = strings;

    const availableSwitchCount = this.getAvailableSwitchCount();
    const isAllowed = this.isNewSwitchInstallationAllowed();

    const columnsSmall = [
      {
        title: strings.homes.detail.switchStatus,
        className: 'status-left',
        key: 'status',
        render: (text, record) => (
            <div style={{display: 'flex', justifyContent: 'center'}}>
                <div style={ {borderRadius:'50%', backgroundColor:this.getStatusColor(record), width: 12, height: 12}}/>
            </div>
        )
      },
      {
        title: strings.homes.switchModel,
        className: 'relayType',
        key: 'relayType',
        render: (text, record) => (
          <div style={{display: 'flex', justifyContent: 'center'}}>
              {!record.relayType ? record.switchType : record.relayType}
          </div>
        )
      },
      {
        title: strings.homes.switchName,
        dataIndex: 'brand',
        key: 'brand',
        width: 95

      },
      {
        title: strings.homes.relayDevice,
        dataIndex: 'deviceName',
        key: 'deviceName',
        width: 95
      },
      {
        title: strings.actionsLabel,
        className: 'text-right',
        key: 'action',
        render: (text, record) => (
            <span style={{ float: 'right' }}>
              {!record.deleted && (
                  <Button.Group style={{ marginRight: 10 }}>
                    <Button
                        type="primary"
                                  disabled={!this.isAllowedToEdit()}
                                  onClick={this.toggleAddOrEditSwitchModal(true, record)}
                              >
                                <Icon type="edit" />
                              </Button>
                            </Button.Group>
                        )}
                {record.deleted ? (
                  <ButtonGroup>
                    <Button
                        type="danger"
                        ghost
                        onClick={this.onDeleteModalShownToggle(true, record)}
                    >
                      <Icon type="undo" /> {msgs.undelete}
                    </Button>
                  </ButtonGroup>
                ) : (
                  <ButtonGroup style={{ marginRight: 10 }}>
                    <Button
                        type="danger"
                        disabled={!this.isAllowedToEdit()}
                        onClick={this.onDeleteModalShownToggle(true, record)}
                    >
                      <Icon type="delete" />
                    </Button>
                  </ButtonGroup>
                )}
            </span>
        )
      }
    ];

    const switchList = meterId ? switches : [];

    return (switchList &&
      <Layout style={{backgroundColor: '#F5F5F5'}}>
        <Layout.Content>
          {`${strings.homes.switchesInstalled}: ${switchList.length}/${
            availableSwitchCount < 0
              ? strings.homes.unlimited
              : availableSwitchCount
          }`}
          {isAllowed !== null ?
              <AddSwitchButton onClick={this.toggleAddOrEditSwitchModal(true)} params={params}/>
              :
              <Text> abc </Text>
          }
          <Table
              pagination={false}
              dataSource={this.flatSwitchList(switchList)}
              columns={columnsSmall}
          />
        </Layout.Content>
        {isLoading && <Spin />}
        {addOrEditSwitchModalIsShown && (
            <AddOrEditSwitchModal
                msgs={strings}
                key="add-or-edit-switch-modal"
                onCancel={this.toggleAddOrEditSwitchModal(false)}
                recordToEdit={recordToEdit}
                isShown={addOrEditSwitchModalIsShown}
                meterId={meterId}
                params={params}
                splittSwitchAndRelay={this.splittSwitchAndRelay}
                deviceList={deviceList}
                onAfterSubmit={this.onAfterAddOrEditSwitchSubmit}
            />)
        }
        {recordToDelete && (
            <Modal
                key="delete-user-modal"
                visible={deleteModalShown}
                onCancel={this.onDeleteModalStateReset}
                onOk={this.deleteSwitch}
                okText={recordToDelete.deleted ? msgs.undelete : msgs.delete}
                okType={recordToDelete.deleted ? 'primary' : 'danger'}
                confirmLoading={deleteModalIsLoading}
                cancelText={msgs.close}
                title={recordToDelete.deleted
                          ? msgs.sureToUndeleteTitle
                          : msgs.homes.confirmDeleteSwitch
                }
            >
                <div>
                  <p>
                    <strong>{recordToDelete.brand}</strong>
                    &nbsp;
                    {recordToDelete.deleted
                        ? msgs.homes.detail.undeleteDeviceOrMeter
                        : msgs.homes.detail.deleteMeterConfirmDescription[1]}
                  </p>
                </div>
            </Modal>
        )
        }
      </Layout>
    );
  }
}

export default connect(
  (state, ownProps) => ({
    ...ownProps,
    isLoading: getSwitchListIsLoading(state),
    switches: getSwitchList(state),
    deviceList: getDeviceList(state),
    cloudPlan: getValidCloudPlan(state),
    addOrEditSwitchModalIsShown: getAddOrEditSwitchModalIsShown(state),
  }),
  {
    onAddOrEditSwitchModalIsShown,
    onSwitchList,
    onSwitchListIsLoading,
    onDeleteSwitch,
    onUndeleteSwitch,
    fetchAllSwitches,
    fetchAllDevices,
    fetchSwitchConnectionStatus
  },
)(SwitchListScreen);
